<h3>
  <span>{{title}}</span>
  <span class="badge badge-secondary">{{badgeCount}}</span>
</h3>
